export default "__VITE_ASSET__QVn9fMiu__"